const blueTooth = {
    namespaced: true,
    state: {
        // 蓝牙连接状态
        bconnect: false,
        // 蓝牙设备
        device: null,
        deivceName: null,
        // 已连接的设备id
        deviceId: null,
        // 蓝牙设备下服务
        service: {},
        // 固定服务id
        serviceId: '0000FFB0-0000-1000-8000-00805F9B34FB',
        // 服务下特征值
        characteristic: {},
        // 固定服务特征值id
        characteristicId: '0000FFB2-0000-1000-8000-00805F9B34FB',
        // 设备列表
        deviceList: []
    },
    getters: {
        get_device(state) {
            return state.device || JSON.parse(localStorage.getItem('blutToothDevice'))
        },
    },
    mutations: {
        set_device(state, device) {
            state.device = device
            localStorage.setItem('blutToothDevice', JSON.stringify(device))
        },
        // REMOVE_MESSAGE_COUNT(state) {
        //     state.todoCount = 0
        //     state.toReadCount = 0
        //     state.todoCountBussiness = 0
        //     sessionStorage.removeItem(todoCountName)
        //     sessionStorage.removeItem(toReadCountName)
        //     sessionStorage.removeItem(todoCountBussinessName)
        // }
    }
}

export default blueTooth